<!--ukey收件人信息-->
<template>
  <div class="module">
    <h5 class="module-title">Ukey收件人信息</h5>
    <div class="module-tips">信息填写后请认真核对，以确保安全收到Ukey</div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="收件人姓名："
            :prop="`settleAccountUkeyTemp.realName`"
            :rules="rules.realName"
          >
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.realName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="收件人联系电话："
            :prop="`settleAccountUkeyTemp.mobile`"
            :rules="rules.mobile"
            label-width="126px"
          >
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.mobile"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="图形验证码："
            :prop="`settleAccountUkeyTemp.imageCode`"
            :rules="rules.imageCode"
            class="graphical-code"
          >
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.imageCode"
              placeholder="请输入图形验证码"
            ></el-input>
            <div class="graphical-code-button">
              <img :src="graphicalSrc" alt="" />
              <el-button
                type="text"
                size="small"
                @click="getGraphicalVerficationCode"
                >换一张
              </el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="短信验证码："
            :prop="`settleAccountUkeyTemp.smsCode`"
            :rules="rules.smsCode"
            label-width="126px"
            class="message-code"
          >
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.smsCode"
              placeholder="请输入短信验证码"
            ></el-input>
            <el-button
              type="text"
              size="small"
              :disabled="verfityCodeDisalbed"
              @click="getMessageVerficationCode"
              >{{ verfityCode }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="收件人公司："
            :prop="`settleAccountUkeyTemp.receiverCompanyName`"
            :rules="rules.receiverCompanyName"
          >
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.receiverCompanyName"
              placeholder="请输入收件人公司"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            label="收件人地址："
            :prop="`settleAccountUkeyTemp.districtId`"
            :rules="rules.districtId"
            class="address"
          >
            <el-select
              v-model="ruleForm.settleAccountUkeyTemp.provinceId"
              placeholder="请选择省"
              @change="provinceChange"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-select
              v-model="ruleForm.settleAccountUkeyTemp.cityId"
              placeholder="请选择市"
              @change="cityChange"
            >
              <el-option
                v-for="item in cityList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-select
              v-model="ruleForm.settleAccountUkeyTemp.districtId"
              placeholder="请选择区/县/街道"
            >
              <el-option
                v-for="item in districtList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.settleAccountUkeyTemp.address"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="module-line"></div>
      <el-form-item prop="checked" label-width="0" style="padding-bottom: 20px">
        <div class="module-agreement">
          <el-checkbox v-model="ruleForm.checked"></el-checkbox>
          <p>
            我已阅读并同意
            <el-button type="text" size="small" @click="openAgreement(1)"
              >《平台会员及用户服务协议》
            </el-button>
            <el-button type="text" size="small" @click="openAgreement(2)"
              >《平台支付规则》</el-button
            >
            <el-button type="text" size="small" @click="openAgreement(3)"
              >《中国石化电商支付平台服务规则》
            </el-button>
          </p>
        </div>
      </el-form-item>
    </el-form>
    <platform-rules ref="platformRules"></platform-rules>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { epecMallUrl } from '@/modules/projectA/api/config';
import { mobileReg } from '@/modules/projectA/utils/verification';
import { paymentAccountOpeningMixins } from '../constant';
import PlatformRules from './platformRules';

export default {
  name: 'UkeyRecipientInfo',
  components: { PlatformRules },
  mixins: [paymentAccountOpeningMixins],
  data() {
    return {
      ruleForm: {
        settleAccountUkeyTemp: {
          address: '',
          applyId: null,
          city: '',
          cityId: null,
          district: '',
          districtId: null,
          id: null,
          imageCode: '',
          messageId: '',
          mobile: '',
          province: '',
          provinceId: null,
          realName: '',
          receiverCompanyName: '',
          smsCode: '',
          trackingNumber: '',
        },
        checked: false,
      },
      graphicalSrc: '@/assets/img/paymenAccount/placeholder.png',
      verfityCode: '获取验证码',
      verfityCodeDisalbed: false,
      waitTime: 60,
      provinceList: [],
      cityList: [],
      districtList: [],
    };
  },
  watch: {},
  created() {
    this.getQueryAreaByCountryCode();
    // 初始化图形验证码
    this.getGraphicalVerficationCode();
  },
  methods: {
    async initData(sourceData) {
      if (sourceData?.settleAccountUkeyTemp) {
        this.ruleForm.settleAccountUkeyTemp = {
          ...sourceData.settleAccountUkeyTemp,
        };
      }
      if (this.ruleForm.settleAccountUkeyTemp.provinceId) {
        this.getCityByAreaId(this.ruleForm.settleAccountUkeyTemp.provinceId);
      }
      if (this.ruleForm.settleAccountUkeyTemp.cityId) {
        this.getDistrictByCityId(this.ruleForm.settleAccountUkeyTemp.cityId);
      }
    },
    // 获取图形验证码
    async getGraphicalVerficationCode() {
      const res = await Api.getEpaySettleAccountUkeyImageCode();
      if (res.code === '200') {
        this.graphicalSrc = res.data;
      }
    },
    // 获取短信验证码
    async getMessageVerficationCode() {
      // 1、需要校验图形验证码是否正确；2、需要验证手机号格式是否正确
      if (!this.ruleForm.settleAccountUkeyTemp.imageCode) {
        this.$message.warning('请输入图形验证码');
        return;
      }
      if (!mobileReg.test(this.ruleForm.settleAccountUkeyTemp.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const res = await Api.sendEpaySettleAccountUkeySMS({
        imageCode: this.ruleForm.settleAccountUkeyTemp.imageCode,
        mobile: this.ruleForm.settleAccountUkeyTemp.mobile,
      });
      if (res.code === '200') {
        this.ruleForm.settleAccountUkeyTemp.messageId = res.data;
        this.messageCountdown();
      }
    },
    // 短信验证码倒计时
    messageCountdown() {
      if (this.waitTime === 0) {
        this.verfityCode = '获取验证码';
        this.waitTime = 60;
        this.verfityCodeDisalbed = false;
      } else {
        this.verfityCodeDisalbed = true;
        this.verfityCode = `${this.waitTime}s后重新发送`;
        this.waitTime--;
        setTimeout(() => {
          this.messageCountdown();
        }, 1000);
      }
    },
    // 省份改变
    provinceChange(val) {
      this.cityList = [];
      this.districtList = [];
      this.ruleForm.settleAccountUkeyTemp.cityId = '';
      this.ruleForm.settleAccountUkeyTemp.districtId = '';
      this.getCityByAreaId(val);
    },
    cityChange(val) {
      this.districtList = [];
      this.ruleForm.settleAccountUkeyTemp.districtId = '';
      this.getDistrictByCityId(val);
    },
    // 查询省份
    getQueryAreaByCountryCode() {
      const params = {
        countryCode: 'CN',
      };
      Api.queryAreaByCountryCode(params).then((res) => {
        if (res.code === '200') {
          this.provinceList = res.data;
        }
      });
    },
    // 查询城市
    getCityByAreaId(provinceAreaId) {
      const params = {
        parentAreaId: provinceAreaId,
      };
      Api.getCityByAreaId(params).then((res) => {
        if (res.code === '200') {
          this.cityList = res.data;
        }
      });
    },
    // 获取区县信息
    getDistrictByCityId(cityAreaId) {
      const params = {
        parentAreaId: cityAreaId,
      };
      Api.getDistrictByCityId(params).then((res) => {
        if (res.code === '200') {
          this.districtList = res.data;
        }
      });
    },
    openAgreement(type) {
      switch (type) {
        case 1:
          window.open(`${epecMallUrl}/platformRules/details/12`);
          break;
        case 2:
          window.open(`${epecMallUrl}/platformRules/details/7`);
          break;
        default:
          this.$refs.platformRules.initData();
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
